export enum ItineraryItemType {
    Boat = 'boat',
    Activity = 'activity',
    Vehicle = 'vehicle',
    Property = 'property',
    Commercial = 'commercial',
    Flight = 'flight',
    Event = 'event',
    Transfer = 'transfer',
    Restaurant = 'restaurant',
    Custom = 'custom',
    PartnerService = 'partnerService',
}

export enum TravelMode {
    DRIVING = 'DRIVING',
    TRANSIT = 'TRANSIT',
    BICYCLING = 'BICYCLING',
    WALKING = 'WALKING',
    FLIGHT = 'FLIGHT',
}
